import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import Point from '../Point'
import classes from './Line.module.scss'
import { useColor } from 'utils/colors'
import {
  ContentBody
} from 'components/Content'

const PointContainer = ({
  name,
  role,
  color,
  lineProgress,
  renderedCurrentStatus,
  isSelected,
  offset,
  onClick,
}) => {
  const pointColor = useColor(color)

  const calcColor = useMemo(() => {
    let calcColor = '#83b92a'

    if (renderedCurrentStatus) {
      calcColor = isSelected ? pointColor : '#bebebe'
    }

    return calcColor
  }, [isSelected, renderedCurrentStatus, pointColor])

  return (
    <span>
      <Point
        isSelected={isSelected}
        name={name}
        role={role}
        style={{
          color: calcColor,
          left: offset + '%'
        }}
        onClick={onClick}
      />
      {isSelected &&
        <div
          className={classes.line}
          style={{
            zIndex: 2,
            backgroundColor: '#83b92a',
            width: lineProgress + '%'
          }}
        />
      }
    </span>
  )
}

export class Line extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,
    isArchived: PropTypes.bool.isRequired,
    permission: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired,
    cardStatuses: PropTypes.array.isRequired,
    lineStatusId: PropTypes.number,
    lineProgress: PropTypes.number.isRequired,
    requestChangeCardStatus: PropTypes.func.isRequired
  }

  render () {
    const {
      cardContext,
      isArchived,
      permission,
      cardStatuses,
      requestChangeCardStatus,
      lineStatusId,
      status,
      lineProgress
    } = this.props

    let renderedCurrentStatus = false

    return cardStatuses.length > 1 ? (
      <ContentBody style={{ paddingTop: 10 }}>
        {cardStatuses.length > 1 &&
          <div className={classes.wrapper}>
            <div
              className={classes.line}
            />
            {cardStatuses.map((cardStatus, index) => {
              const isSelected = lineStatusId === cardStatus.id
              if (isSelected) renderedCurrentStatus = true

              const length = cardStatuses.length - 1
              const offset = Math.floor((index / length) * 100)

              const onClick =
                isSelected || isArchived || !permission.member
                  ? null
                  : () => {
                    requestChangeCardStatus({
                      cardId: cardContext.id,
                      cardStatusId: cardStatus.id
                    })
                  }

              return (
                <PointContainer
                  key={index}
                  name={cardStatus.name}
                  role={cardStatus.role}
                  color={cardStatus.color}
                  lineProgress={lineProgress}
                  renderedCurrentStatus={renderedCurrentStatus}
                  isSelected={isSelected && status.id === cardStatus.id}
                  offset={offset}
                  onClick={onClick}
                />
              )
            })}
          </div>
        }
      </ContentBody>
    ) : null
  }
}

export default Line
